import { Summarization } from '@/components/summarization'

export default function SummarizationPage() {
  return <Summarization />
}
